
import { Component, Vue, Prop } from 'vue-property-decorator';

import animationFrame from '@/utils/animationFrame';
import fetchCommonInfo from '@/utils/commonConfig';

import NoticePanel from './panel.vue';

// 运动前的延迟
const START_DELAY = 5 * 1000;
// 每秒移动的距离，由此计算总时长 Math.ceil(noticeList.width()/DISTANCE_PER_SEC);
const DISTANCE_PER_SEC = 45;

@Component({
  components: {
    NoticePanel,
  },
})
class AnnouncementNotice extends Vue {
  @Prop() wpaDetail: any;
  // 公告列表
  noticeList: Array<any> = [];
  // 是否横向滚动
  needMove: boolean = false;
  // 滚动计时器
  moveTimer: any = null;
  // 公告列表样式
  listStyle: any = {
    transitionDuration: '0s',
    left: 0,
  };
  /**
   * 组件外层会加权限位判断是否展示公告
   * 此处的showNotice是在公告接口未返回数据时，控制内容不展示
   */
  showNotice: boolean = false;
  get isMobile() {
    return !this.$platform.pc;
  }
  created() {
    this.init();
  }

  showPop(): void {
    const panel: any = this.$refs.noticePanel;
    panel.open = true;
  }

  closeNotice(): void {
    this.showNotice = false;
  }

  init(): void {
    this.resetMove();
    this.fetchNotice();
  }

  fetchNotice(): void {
    const { kfuin, fid: wpaId, key } =  this.wpaDetail;
    const body = {
      kfuin,
      wpaId,
      key,
      fields: ['announcement'],
    };
    fetchCommonInfo(body, ({ announcement = {} }: { announcement: any }) => {
      const tmp = announcement.rpt_get_resource_rsp;
      if (!tmp) return;
      this.noticeList = tmp.map(({ str_result_node_json }) => (JSON.parse(str_result_node_json)));
      this.showNotice = true;
      this.$nextTick(() => this.startMove());
    });
  }

  resetMove(): void {
    this.noticeList = [];
    if (this.moveTimer) clearTimeout(this.moveTimer);
    this.listStyle.transitionDuration = '0s';
    animationFrame(() => this.listStyle.left = 0);
  }

  startMove(): void {
    this.moveTimer = setTimeout(() => {
      const outerDom: any = this.$refs.noticeContent;
      const innerDom: any = this.$refs.noticeList;
      const outerWidth = outerDom.clientWidth;
      const innerWidth = innerDom.clientWidth / 2;
      console.log(1111, outerWidth, innerWidth);
      if (innerWidth <= outerWidth) return;
      this.needMove = true;
      this.move(innerWidth);
    }, START_DELAY);
  }

  move(width): void {
    const animationDuration = Math.ceil(width / DISTANCE_PER_SEC);
    this.listStyle.transitionDuration = `${animationDuration}s`;
    animationFrame(() => this.listStyle.left = `${0 - width}px`);
    setTimeout(() => {
      this.listStyle.transitionDuration = '0s';
      animationFrame(() => {
        this.listStyle.left = 0;
        animationFrame(() => this.move(width));
      });
    }, animationDuration * 1000);
  }
}

export default AnnouncementNotice;
